import React from "react";

import error404 from "../../img/404.svg";

const Error = () => {
  return (
    <div className="error">
      <a href="https://sub.by/">
        <img src={error404} alt="" />
      </a>
    </div>
  );
};

export default Error;
